import React from 'react';
import { UrlPreviewStyled, UrlPreviewLabel } from "./style";
var UrlPreview = function UrlPreview(_ref) {
  var labelText = _ref.labelText,
    inputValue = _ref.inputValue;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UrlPreviewLabel, null, labelText), /*#__PURE__*/React.createElement(UrlPreviewStyled, null, /*#__PURE__*/React.createElement("a", {
    href: inputValue,
    target: "_blank",
    rel: "noreferrer"
  }, inputValue)));
};
export default UrlPreview;